<template>
  <b-col class="m-auto text-center align-items-center">
    <img
      src="../../assets/login/mail_amarelo.svg"
      alt="Envelope com carta"
      class="w-50 mb-4"
    />

    <h2 class="text-tertiary mb-4">
      <span class="medium">{{
        resources.page.login.password.passwordSuccess
      }}</span>
    </h2>
    <b-form class="w-100">
      <b-button
        @click.enter.prevent="toLogin()"
        type="submit"
        variant="tertiary"
        class="col-12"
      >
        <i class="mdi mdi-spin pr-2" v-bind:class="{ 'mdi-loading': false }"></i
        >{{ resources.general.buttons.goLogin }}
      </b-button>
    </b-form>
  </b-col>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: mapGetters({
    resources: 'resources',
  }),
  methods: {
    toLogin() {
      this.$router.push({ name: 'login.auth' })
    },
  },
}
</script>
